export default {
  locales: {
    it: {
      validation: {
        required() {
          return `Il campo è richiesto`
        },
        email() {
          return `Il campo non è valido`
        },
      },
      ui: {
        incomplete: 'Modulo incompleto.',
      },
    },
    en: {
      validation: {
        required() {
          return `The field is required`
        },
        email() {
          return `The field is invalid`
        },
      },
      ui: {
        incomplete: 'Form incomplete.',
      },
    },
  },
  locale: 'it',
}
